module.exports = __webpack_public_path__ + "static/media/Titulacion.7252c69e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Titulacion.jpg
// module id = 12
// module chunks = 0